import React, { useState } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { ReportBaseTemplate } from "../../Components/ReportBaseTemplate";
import { callAPI ,LoacalVariables,Method } from "../../commonFunctions/CommonFunctions";
import dayjs from "dayjs";

export const EstimationReport: React.FC = () => {
  const [rows, setRows] = useState<any[]>([]);

  // later you can modify these column names
  const estimationColumns: GridColDef[] = [
    { field: "customerName", headerName: "Customer Name", flex: 1 },
    { field: "estimateCount", headerName: "Estimate Count", flex: 1 },
    { field: "totalAmount", headerName: "Total Amount", flex: 1 },
    { field: "totalDiscount", headerName: "Total Discount", flex: 1 },
    { field: "totalTax", headerName: "Total Tax", flex: 1 },
    { field: "totalWithTax", headerName: "Sale With Tax", flex: 1 },
  ];

 const handleApply = async (payload: any) => {
  try {
    const fromDate = dayjs(payload.fromDate).format("YYYY-MM-DD");
    const toDate = dayjs(payload.to).format("YYYY-MM-DD");

    const userId = localStorage.getItem(LoacalVariables.UserId);
    if (!userId) {
      alert("UserId not found. Please login again.");
      return;
    }

    const query = `?fromdate=${fromDate}&to=${toDate}&userId=${userId}`;

    const response = await callAPI(
      `FinancialReport/Estimate-report${query}`,
      Method.GET
    );

    console.log("API Response:", response);

    const reportArray = response?.data?.data || [];

    setRows(
      reportArray.map((row: any, index: number) => ({
        ...row,
        id: index + 1,
      }))
    );
  } catch (err) {
    console.log("Error fetching Estimation Report", err);
  }
};

  

  return (
    <ReportBaseTemplate
      title="Estimation Report"
      columns={estimationColumns}
      rows={rows}
      onApply={handleApply}
    />
  );
};

export default EstimationReport;
